import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PoliciesTable from "./PoliciesTable";
import { getPolicies } from "../../store/AsyncMethods/PoliciesMethod";
import { usePermissions } from "../../permissions/PermissionContext";

export default function PoliciesMain() {
  const { canOpen } = usePermissions();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (user) {
      dispatch(getPolicies());
    }
  }, []);

  return (
    <div className="mx-3">
      <div className="flex justify-end">
        {canOpen("/add-policies") && (
          <Button
            label="Add Policies"
            icon="pi pi-plus"
            className="p-primary-btn"
            onClick={() => navigate("/add-policies")}
          />
        )}
      </div>

      <div className="my-4">
        <PoliciesTable />
      </div>
    </div>
  );
}
